/**
 * @fileoverview What the share studio's "Your handle" chip does (B85). With no
 * handle on the profile the chip is a normal choice: tapping it opens the
 * profile's links screen over the share, and a saved handle turns the chip on.
 * Only a member tending someone else's garden still cannot choose it (B37).
 *
 * Where: ShareStepBands (DetailsBand).
 * Words: none.
 *
 * @module handleChip
 */

/** What the chip is, from what the share knows. */
export interface HandleChipState {
  /** True when the chip cannot be chosen: a member tending another's garden whose owner has no handle. */
  disabled: boolean;
  /** True when tapping it opens the profile's links screen, because the gardener has no handle yet. */
  opensSetup: boolean;
  /** True when it shows as chosen (it is on and there is a handle to print). */
  pressed: boolean;
}

/**
 * Works out the "Your handle" chip's state.
 *
 * @param on - Whether the handle is switched on in the choices.
 * @param hasHandle - Whether a handle is available to print.
 * @param tending - Whether a member is tending someone else's garden.
 * @returns disabled, opensSetup and pressed.
 */
export function handleChipState(on: boolean, hasHandle: boolean, tending: boolean): HandleChipState {
  return {
    disabled: !hasHandle && tending,
    opensSetup: !hasHandle && !tending,
    pressed: on && hasHandle,
  };
}
